import { annotationPlugin } from "@features/custom-annotations";

import { chartDataManagerPlugin } from "./chart-data-manager-plugin";
import { highlightActiveDatasetPlugin } from "./highlight-active-dataset-plugin";

export const plugins = [
  annotationPlugin,
  chartDataManagerPlugin,
  // highlightActiveDatasetPlugin,
];
